export default __webpack_public_path__ + "static/media/CRS_7128-HDR-min.9ed42eaf.jpg";